import { Flex, Image, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";

import logo from "/headerLogo.png";

import { AppRoute } from "../../constants.ts";

const HeaderLogo = () => {
  const navigate = useNavigate();

  return (
    <Flex
      gap={12}
      align="center"
      justify="center"
      style={{ cursor: "pointer" }}
      onClick={() => navigate(AppRoute.Home)}
    >
      <Image src={logo} alt="Logo" height={50} />
      <Text size={24} style={{ fontFamily: "Poppins SemiBold" }}>
        Aureous
      </Text>
    </Flex>
  );
};

export default HeaderLogo;
